import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpService } from '@core/shared';

import { ParamsBuilderService } from '@core/shared/services/params-builder.service';

import {
  UrlBuilder,
  GET_POWERBI_REPORT
  
} from '@core/core-api-variables';

@Injectable()
export class EmbeddedReportService {

  constructor(public http: HttpService,private paramsBuilderService : ParamsBuilderService) { }

  getEmbeddedReport(embeddedReportPageId:string,culture:string,fallBackCulture:string): Observable<any> {            
    let data = { embeddedReportPageId,culture,fallBackCulture }
    let url = UrlBuilder(GET_POWERBI_REPORT, data);
    return this.http.get(url).pipe(map((response: any) => {
      return response;
    }));
    
  } 
}
